import * as React from 'react';
import { observer } from 'mobx-react-lite';

export interface CalendarConflictGroupItemProps {
    content: () => JSX.Element[];
}

const CalendarConflictGroupItem = observer(function CalendarConflictGroupItem(
    props: CalendarConflictGroupItemProps
) {
    return <>{props.content()}</>;
});
export default CalendarConflictGroupItem;
